<template>
  <AppShell :show-navigation="showNavigation" :user="user" :current-club="currentClub">
    <router-view />
  </AppShell>
</template>

<script>
import AppShell from './components/layout/AppShell.vue';

export default {
  name: 'App',
  components: { AppShell },
  data() {
    return {
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1440,
    };
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    currentClub() {
      return this.$store.getters['clubs/currentClub'];
    },
    isDesktop() {
      return this.viewportWidth >= 1024;
    },
    showNavigation() {
      const path = String(this.$route.path || '');
      const isBookPage = path.startsWith('/book');
      const isClubDetailsPage = /^\/clubs\/\d+/.test(path);

      if (!this.$store.getters['auth/isAuthenticated']) return false;
      if (path === '/login') return false;
      if (isBookPage && !this.isDesktop) return false;
      if (isClubDetailsPage) return false;

      return true;
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.viewportWidth = window.innerWidth;
    },
  },
};
</script>

<style src="./App.css"></style>